export default __webpack_public_path__ + "static/media/icetracklogo.dcd9a6e4.png";